import type { ClientChatResponse } from '../types/ClientMessage';

const TOOL_COMPONENT_FENCE = /```json\+\w+[\s\S]*?```\s*/g;

function stripToolComponents(content: string): string {
  return content.replace(TOOL_COMPONENT_FENCE, '').trim();
}

function toExportableSection(message: ClientChatResponse): string | null {
  if (message.isError) return null;
  const stripped = stripToolComponents(message.content);
  if (!stripped) return null;
  const heading = message.role === 'user' ? '## User' : '## Assistant';
  return `${heading}\n\n${stripped}`;
}

export function formatConversationAsMarkdown(title: string, messages: ClientChatResponse[]): string {
  const sections = messages
    .map(toExportableSection)
    .filter((section): section is string => section !== null);
  if (sections.length === 0) return `# ${title}\n`;
  return `# ${title}\n\n${sections.join('\n\n---\n\n')}\n`;
}
